'use strict';
import React from 'react';
import AppHeader from '../../../components/layout/AppHeader.jsx';
import { IdleTimer } from '../../../components/index.jsx';
import HomeContainer from '../../home/HomeContainer.jsx';
import { useProjectsQuery } from '@/redux/services/portal/projects.api';
import '../../../theme/theme.css';
import { useLoadingState } from '@/contexts/LoadingContext';
import('../../../theme/css/material-icons.css');

export const MainLayout = ({
	match,
	...props
}) => {
	const { data: projects, isLoading } = useProjectsQuery();

	// Register loading state with global loading context
	useLoadingState('main-layout', isLoading);

	if (isLoading) {
		return null; // GlobalLoading will handle the spinner
	}

	return (
		<div data-testid="mainLayout">
			<IdleTimer {...props} />
			<AppHeader />
			<HomeContainer
				{...props}
				match={match}
				isLoading={isLoading}
				projects={projects}
			/>
		</div>
	);
};
